export default __webpack_public_path__ + "static/media/gallery_02.8e4aae5c.jpg";